import { Box, Divider, Grid, Stack } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import RadioGroup from './RadioGroupComponent';
// import { toastSuccess, toastFail } from "@tms/components/Toast";

import Button from '@mui/material/Button';

// import {
//   useFeedbackModuleQuestion,
//   useFeedbackQuestion,
//   useMutationSaveFeedbackAnswer,
//   useMutationSaveFeedbackModuleAnswer
// } from "@tms/services/tms-feedback";

import UserTextInput from 'components/UserInput/UInput';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {
  useFeedbackQuestion,
  useMutationSaveFeedbackModuleAnswer
} from 'redux/reducers/user/dashboard/tms-feedback';

interface IFeedbackModuleModal {
  open: boolean;
  handleClose: () => void;
  courseId: string;
}

interface IFeedbackModal {
  dailySessionId: string;
  openFeedbackModal: any;
  feedbackQuestionRoutineId: number | null;
  handleCloseFeedbackModal: () => void;
  items?: any;
  //   feedbackQuestion: FeedBackQuestion;
}

interface IFeedbackAns {
  daily_session: string;
  routine_feedback_que_id: string;
  feedback_question_id: string;
  feedback_point: string;
  feedback_answer: string;
}

const FeedbackModuleModal = ({
  dailySessionId,
  openFeedbackModal,
  feedbackQuestionRoutineId,
  handleCloseFeedbackModal,
  items
}: IFeedbackModal) => {
  const { control, reset, watch, setValue, handleSubmit } = useForm({
    defaultValues: {
      feedbackAnswers: [] as IFeedbackAns[]
    }
  });

  const feedbackAns = watch('feedbackAnswers');

  const { data: feedbackQuestion = [] } = useFeedbackQuestion(
    feedbackQuestionRoutineId?.toString() ?? '',
    'module'
  );
  const { mutateAsync, isLoading } = useMutationSaveFeedbackModuleAnswer();

  const onSubmitHandler = async () => {
    try {
      await mutateAsync(feedbackAns);
      handleCloseFeedbackModal();
      reset();
      toast.success('Success');
    } catch (error: any) {
      //backend neeeds to send specific message

      toast.error(error.response.data[0].non_field_errors);
    }
  };

  const feedbackQuestionList = React.useMemo(
    () => feedbackQuestion?.flatMap((fq) => fq.feedback_question_details) ?? [],
    [feedbackQuestion]
  );

  React.useEffect(() => {
    if (feedbackQuestionList.length) {
      const mulitpleAnswers = feedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 'm';
        })
        .map((data, index) => {
          return {
            course: dailySessionId,
            // daily_session: "7",
            routine_feedback_que_id:
              feedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_point: '',
            feedback_answer: ''
          };
        });

      const shortAnswers = feedbackQuestionList
        .filter((data, index) => {
          return data.question_type == 's';
        })
        .map((data, index) => {
          return {
            course: dailySessionId,
            // daily_session: "7",
            routine_feedback_que_id:
              feedbackQuestion?.[0]?.routine_feedback_que_id?.toString() ?? '',
            feedback_question_id: data.tms_feedback_question_id,
            feedback_answer: ''
          };
        });

      reset({ feedbackAnswers: [...mulitpleAnswers, ...shortAnswers] });
    }
  }, [feedbackQuestionList, feedbackQuestion, dailySessionId]);

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={openFeedbackModal}
        onClose={handleCloseFeedbackModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        {feedbackQuestionList?.length > 0 ? (
          <>
            <DialogTitle id="alert-dialog-title">
              <Typography variant="h4" gutterBottom sx={{ fontSize: '28px' }}>
                {items?.course?.title}
              </Typography>{' '}
            </DialogTitle>
            <Divider />

            <DialogContent>
              <form onSubmit={handleSubmit(onSubmitHandler)}>
                {feedbackQuestionList
                  .filter((q) => q.question_type === 'm')
                  .map((item, index) => {
                    return (
                      <>
                        <Grid container columnSpacing={4}>
                          <Grid item xs={5}></Grid>
                          <Grid item xs={7} sx={{ float: 'right' }}>
                            <Stack direction={'row'} justifyContent={'space-around'}>
                              {[...Array(4)].map((item, index) => (
                                <>
                                  <Typography>{index + 1}</Typography>
                                </>
                              ))}
                            </Stack>
                          </Grid>
                        </Grid>
                        <RadioGroup
                          key={item.tms_feedback_question_id}
                          item={item}
                          selectedValue={
                            feedbackAns.find(
                              (a) => a.feedback_question_id === item.tms_feedback_question_id
                            )?.feedback_point ?? ''
                          }
                          onChange={(value) => {
                            setValue(
                              'feedbackAnswers',
                              feedbackAns.map((a, inde) => ({
                                ...a,
                                feedback_point:
                                  a.feedback_question_id === item.tms_feedback_question_id
                                    ? value
                                    : a.feedback_point
                              }))
                            );
                          }}
                        />
                      </>
                    );
                  })}

                {feedbackQuestionList
                  .filter((q) => q.question_type === 's')
                  .map((item) => {
                    return (
                      <>
                        <Grid container justifyContent={'space-between'}>
                          <Grid xs={6}>
                            <Typography>{item?.question}</Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <UserTextInput
                              label={'Answer the question'}
                              type="text"
                              name="dis"
                              control={control}
                              sx={{ height: '50px' }}
                              value={
                                feedbackAns.find(
                                  (a) => a.feedback_question_id === item.tms_feedback_question_id
                                )?.feedback_answer ?? ''
                              }
                              onChange={({ target: { value } }) => {
                                setValue(
                                  'feedbackAnswers',
                                  feedbackAns.map((a) => ({
                                    ...a,
                                    feedback_answer:
                                      a.feedback_question_id === item.tms_feedback_question_id
                                        ? value
                                        : a.feedback_answer
                                  }))
                                );
                              }}
                            />
                          </Grid>
                        </Grid>
                      </>
                    );
                  })}
                <>
                  <Button
                    variant="outlined"
                    onClick={handleCloseFeedbackModal}
                    sx={{ marginRight: '8px' }}>
                    Cancel
                  </Button>
                  <Button variant="contained" autoFocus type="submit" disabled={isLoading}>
                    {isLoading ? "Submitting.." : "Submit"}
                  </Button>
                </>
              </form>
            </DialogContent>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '300px'
            }}>
            <h4>No Questions here</h4>
          </Box>
        )}
      </Dialog>
    </div>
  );
};

export default FeedbackModuleModal;
